<template>
    <div class="o-crop">
        <template v-if="agrofag">
            <m-title :title="agrofag.name" />
            <div class="l-row">
                <div class="l-row__column">
                    <template
                        v-if="agrofag.agrofag_type && agrofag.agrofag_type.name"
                    >
                        <p class="a-label">Rodzaj</p>
                        <p class="a-text">{{ agrofag.agrofag_type.name }}</p>
                    </template>
                    <template v-if="agrofag.ingredients">
                        <p class="a-label">Składniki</p>
                        <p class="a-text">{{ agrofag.ingredients }}</p>
                    </template>
                </div>
            </div>
            <div
                class="l-row"
                v-if="agrofag.description && descriptionWithoutTags"
            >
                <div class="l-row__column">
                    <p class="a-label">Informacje o produkcie</p>
                    <p class="a-text" v-html="agrofag.description"></p>
                </div>
            </div>
            <m-gallery
                v-if="agrofag.photos && agrofag.photos.length > 0"
                :images="photos"
            />
            <template
                v-if="agrofag.protectors && agrofag.protectors.length > 0"
            >
                <m-tabs
                    v-if="agrofagRelated"
                    :items="agrofagRelated"
                    @input="tab = $event.value"
                    :selected="tab"
                    :center="true"
                />
                <m-list
                    router-single-name="protector"
                    :list="agrofag.protectors"
                >
                    <template slot="list" slot-scope="props">
                        <div class="m-list__itemPhoto">
                            <a-image
                                v-if="
                                    props.item.photos &&
                                        props.item.photos.length > 0 &&
                                        !!props.item.photos.find(
                                            item => item.is_main === true
                                        )
                                "
                                :src="
                                    props.item.photos.find(
                                        item => item.is_main === true
                                    ).full_uri
                                "
                                :alt="props.item.name"
                            />
                            <a-icon v-else icon="Protectors" />
                        </div>
                        <p
                            class="m-list__itemTitle m-list__itemTitle--margins m-list__itemTitle--capitalize"
                            :style="
                                authIsAdvisor && props.item.position_group
                                    ? { color: props.item.position_group.hex }
                                    : false
                            "
                        >
                            {{ props.item.name }}
                            <span
                                v-if="props.item.is_deleted"
                                class="m-list__itemTitleRed"
                            >
                                <br />archiwalny
                            </span>
                        </p>
                        <div class="m-list__itemIcons">
                            <a-icon
                                v-if="props.item.youtube_link"
                                class="m-list__icon"
                                icon="Video"
                            />
                            <a-icon
                                class="m-list__icon"
                                :icon="
                                    props.item.notes &&
                                    props.item.notes.length > 0
                                        ? 'Note'
                                        : 'NoteLight'
                                "
                            />
                            <a-icon
                                class="m-list__icon"
                                :icon="
                                    props.item.is_favorite
                                        ? 'Favorite'
                                        : 'FavoriteLight'
                                "
                            />
                        </div>
                    </template>
                </m-list>
            </template>
        </template>
        <a-spinner v-else />
    </div>
</template>

<script>
export default {
    metaInfo() {
        return {
            title: this.metaTitle
        }
    },
    data() {
        return {
            tab: '',
            metaTitle: 'Agrofag'
        }
    },

    computed: {
        agrofag() {
            return this.$store.getters.agrofag
        },
        agrofagStatus() {
            return this.$store.getters.agrofagStatus
        },
        agrofagRelated() {
            if (this.agrofag.protectors.length > 0) {
                return [
                    {
                        value: 'protectors',
                        label: 'Powiązane środki'
                    }
                ]
            } else {
                return null
            }
        },
        descriptionWithoutTags() {
            return this.agrofag.description.replace(/(<([^>]+)>)/gi, '')
        },
        photos() {
            return this.agrofag.photos.map(item => item.full_uri)
        },
        authIsAdvisor() {
            return this.$store.getters.authIsAdvisor
        }
    },
    methods: {
        fetchAgrofag() {
            if (!isNaN(this.$route.params.id)) {
                this.$store
                    .dispatch('fetchAgrofag', this.$route.params.id)
                    .then(() => {
                        this.metaTitle = this.agrofag.name
                        // init tabs
                        if (
                            this.agrofag.protectors &&
                            this.agrofag.protectors.length > 0
                        ) {
                            this.tab = 'protectors'
                        }
                    })
            } else {
                this.$router.push({ name: 'error404' })
            }
        }
    },
    created() {
        this.fetchAgrofag()
    }
}
</script>
